import { useEffect, useState } from 'react';

const useValueWithLast = (value?: string | number) => {
  const [currentValue, setCurrentValue] = useState(
    value !== undefined ? value : null,
  );
  const [lastValue, setLastValue] = useState(
    value !== undefined ? value : null,
  );

  useEffect(() => {
    if (value !== undefined) {
      setLastValue(value);
      setCurrentValue(value);
    }
  }, [value]);

  return [currentValue, lastValue];
};

export default useValueWithLast;
